import {
  BannerImg,
  BannerPage,
  ImageInner,
  ImageInnerBox,
  BannerButton,
  BannerButtonRequestA,
  BannerLayout,
  BannerDivRow,
  BannerTextSection,
  BannerButtonLayout,
} from './Banner.style';
import React, { PropsWithChildren, useCallback, useEffect, useState } from 'react';
import { Trans } from 'react-i18next';

import * as banner from './BannerImages';
import Modal from './Modal/Modal';

import ModalSubscribe from './Modal/ModalSubscribe';
import ModalDone from './Modal/ModalDone';
import { useLocation } from 'react-router-dom';
import { LabelColor, PaddingDTM, ParagraphColor, Spacing } from '@pages/CommonStyle/common.style';
import { DisplayH1, DisplayH1fff } from '@components/Text/HeadingTagDisplay.style';
import { DivAllCenter, DivFlexColumn, DivFlexRow } from '@pages/CommonStyle/commonDiv.style';
import i18n from '@pages/i18n';
import { StyledGridContainer } from '@components/Grid/Grid.style';
import { HeadingH3 } from '@components/Text/Heading/Heading.style';
import { StyledParagraph } from '@components/Text';
import { BannerRtlsMobile } from '@assets/images/main/home';
import { SolutionRequestButton } from '@pages/Main/Home/components/Solution/Solution.style';
import { BtnStyled } from '@pages/CommonStyle/commonBtn';
import { DivPaddingRight } from '@pages/Enterprise/Technology/Technology.style';

interface ModalDefaultType {
  pageName: string;
  path: any;
  onRequestSection: () => void;
}

const Banner = ({ pageName, path, onRequestSection }: PropsWithChildren<ModalDefaultType>) => {
  const location = useLocation();
  const [isDownload, setDownloadModal] = useState(false);
  const [isSubscribeOpen, setSubscribeOpen] = useState(false);
  const [isDoneOpen, setDoneOpen] = useState(false);

  const [getEmail, onGetEmail] = useState<string>('');
  const handleSaveEmail = (email) => {
    onGetEmail(email);
  };

  const onClickToggleModal = useCallback(() => {
    setDownloadModal(!isDownload);
  }, []);
  const onSuccess = useCallback(() => {
    setDownloadModal(false);
  }, []);

  const onSubscribe = () => {
    setSubscribeOpen(!isSubscribeOpen);
  };
  const onDone = () => {
    setDoneOpen(!isDoneOpen);
  };

  const getLang = () => {
    if (location.pathname.includes('jp')) {
      return '/jp';
    } else if (location.pathname.includes('cn/')) {
      return '/cn';
    } else if (location.pathname.includes('en/')) {
      return '/en';
    } else if (location.pathname.includes('vi/')) {
      return '/vi';
    } else {
      return '';
    }
  };

  const checkDisable = () => {
    if (i18n.language === 'cn' || i18n.language === 'vi') {
      return true;
    }
    if (i18n.language !== 'ko') {
      if (
        location.pathname.includes('digital-twin') ||
        location.pathname.includes('city') ||
        location.pathname.includes('public') ||
        location.pathname.includes('forklift') ||
        location.pathname.includes('steel') ||
        location.pathname.includes('education') ||
        location.pathname.includes('sop') ||
        location.pathname.includes('fire') ||
        location.pathname.includes('mobile') ||
        location.pathname.includes('manage')
      ) {
        return true;
      }
    }
    return false;
  };

  return (
    <BannerPage>
      <StyledGridContainer>
        <PaddingDTM d="64" t="64" m="32" />
        <BannerDivRow>
          <BannerImg img={banner[pageName].banner} />

          <BannerTextSection>
            <HeadingH3 size="xxsmall">
              <Trans i18nKey={path.type} />
            </HeadingH3>
            <Spacing pixel="4" />
            <DisplayH1 size="medium">
              <Trans i18nKey={path.banner.title} />
            </DisplayH1>

            <Spacing pixel="16" />
            <StyledParagraph size="medium" weightM={200}>
              <Trans i18nKey={path.banner.desc} />
            </StyledParagraph>
            <Spacing pixel="32" />

            <BannerButtonLayout>
              {checkDisable() ? (
                <>
                  <SolutionRequestButton href={i18n.language === 'ko' ? `/request` : `/${i18n.language}/request`} rel="noopener noreferrer">
                    <LabelColor size="large" color={'#FFFFFF'}>
                      <Trans i18nKey={'nav.support.request'} />
                    </LabelColor>
                  </SolutionRequestButton>
                </>
              ) : (
                <>
                  <SolutionRequestButton onClick={onClickToggleModal}>
                    <LabelColor size="large" color={'#FFFFFF'}>
                      <Trans i18nKey={'solutionCommon.banner.download'} />
                    </LabelColor>
                  </SolutionRequestButton>
                </>
              )}

              <BtnStyled borderColor="#000" bgColor="#000" href={`${getLang()}/pricing/1`}>
                <LabelColor size="large" color="#fff">
                  <Trans i18nKey={'solutionCommon.banner.request'} />
                </LabelColor>
              </BtnStyled>
            </BannerButtonLayout>
          </BannerTextSection>
        </BannerDivRow>
      </StyledGridContainer>

      {isDownload && (
        <Modal onClickToggleModal={onSuccess} content="download" onSubscribe={onSubscribe} onSaveEmail={handleSaveEmail} pageName={pageName}></Modal>
      )}

      {isSubscribeOpen && <ModalSubscribe onClickToggleModal={onSubscribe} onDone={onDone} email={getEmail}></ModalSubscribe>}

      {isDoneOpen && <ModalDone onClickToggleModal={onDone}></ModalDone>}
    </BannerPage>
  );
};

export default Banner;
